// FAQModal.js
import React from 'react';

export default function FAQModal({ open, onClose, onPrivacyPolicy, onTermsOfService}) {
  if (!open) return null;

  // 자주 묻는 질문 목록
const faqList = [
  {
    question: "What is Idle MNWalk?",
    answer: "It's an idle game you can leave running in the background.\nThrough gameplay, you can meet a variety of Pet characters.",
  },
  {
    question: "What is Pet mining?",
    answer: "Pet is mining an in-game currency called PetCoin.",
  },
  {
    question: "How can I mine PetCoin?",
    answer: "Mining is available after 5 minutes have accumulated, up to a maximum of 3 hours.\nMake sure to claim regularly!",
  },
  {
    question: "How is the leaderboard determined?",
    answer: "Currently, it is based on the total amount of PetCoin mined.\nThe logic may be updated or extended for more fun in the future.",
  },
  {
    question: "Is this all the content available?",
    answer: "More fun features and new Pet characters will be added through future updates.",
  },
  {
    question: "I'm having an issue. Where can I get help?",
    answer: "Please leave a comment on the @MNWalk_official Twitter account.",
  },
  {
    question: "Privacy Policy?",
    answer: (
        <span
          style={{
            color: "#3AA8B8",
            textDecoration: "underline",
            cursor: "pointer"
          }}
          onClick={onPrivacyPolicy}
        >
          Privacy Policy Page
        </span>
      ),
  },
  
  {
    question: "Terms of Service?",
    answer: (
        <span
          style={{
            color: "#3AA8B8",
            textDecoration: "underline",
            cursor: "pointer"
          }}
          onClick={onTermsOfService}
        >
          Terms of Service Page
        </span>
      ),
  },
];


  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: '90%',
          maxWidth: 420,
          background: 'linear-gradient(180deg, #4FC3D4 0%, #3AA8B8 100%)',
          borderRadius: 24,
          position: 'relative',
          padding: '32px 20px 20px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
          maxHeight: '86vh',
          overflow: 'hidden',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* 배경 데코레이션 */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `
              radial-gradient(circle at 20% 80%, rgba(255,255,255,0.1) 0%, transparent 50%),
              radial-gradient(circle at 80% 20%, rgba(255,255,255,0.08) 0%, transparent 50%)
            `,
            pointerEvents: 'none',
          }}
        />
        {/* 닫기 버튼 */}
        <button
          onClick={onClose}
          style={{
            border: 'none',
            background: 'rgba(255,255,255,0.3)',
            fontSize: 20,
            position: 'absolute',
            top: 16,
            right: 16,
            cursor: 'pointer',
            width: 32,
            height: 32,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            fontWeight: 'bold',
            zIndex: 10,
          }}
        >
          ✕
        </button>
        {/* 헤더 */}
        <h2
          style={{
            margin: '0 0 20px 0',
            textAlign: 'center',
            color: '#fff',
            fontSize: 26,
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '1px',
            textShadow: '0 2px 4px rgba(0,0,0,0.18)',
          }}
        >
          • FAQ •
        </h2>
        {/* FAQ 목록 */}
        <div
          style={{
            maxHeight: '400px',
            overflowY: 'auto',
            paddingRight: 4,
          }}
        >
          {faqList.map((item, idx) => (
            <div
              key={idx}
              style={{
                background: 'rgba(255,255,255,0.92)',
                borderRadius: 14,
                marginBottom: 15,
                padding: '13px 17px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
                display: 'flex',
                flexDirection: 'column',
                gap: 7,
              }}
            >
              <div
                style={{
                  fontWeight: 700,
                  color: '#3AA8B8',
                  fontSize: 15,
                  marginBottom: 0,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4,
                }}
              >
                <span style={{fontSize:17}}>Q.</span> {item.question}
              </div>
              <div
  style={{
    color: '#444',
    fontSize: 14,
    lineHeight: 1.6,
    paddingLeft: 22,
  }}
>
   {typeof item.answer === "string"
    ? item.answer.split('\n').map((line, i) => (
        <React.Fragment key={i}>
          {line}
          {i !== item.answer.split('\n').length - 1 && <br />}
        </React.Fragment>
      ))
    : item.answer}
</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
